var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteBelt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D7E6F0;}\r\n\t.st1{fill:#AAC3D7;}\r\n\t.st2{fill:#8CAAC8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344,224H168c-8.8,0-16-7.2-16-16V32h208v176C360,216.8,352.8,224,344,224z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168,272v216c0,4.4,3.6,8,8,8h64c4.4,0,8-3.6,8-8V296c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v192 c0,4.4,3.6,8,8,8h64c4.4,0,8-3.6,8-8V272c0-8.8-7.2-16-16-16H184C175.2,256,168,263.2,168,272z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360,32l81.9,81.9c9,9,14.1,21.2,14.1,33.9V248c0,4.4-3.6,8-8,8h-56c-4.4,0-8-3.6-8-8v-88l-24-24V32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,32l-81.9,81.9c-9,9-14.1,21.2-14.1,33.9V248c0,4.4,3.6,8,8,8h56c4.4,0,8-3.6,8-8v-88l24-24V32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360,320H152v-48c0-8.8,7.2-16,16-16h176c8.8,0,16,7.2,16,16V320z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.9,22.8c-0.6-3.8-3.9-6.8-7.9-6.8h-2.1L152,208c0,8.8,7.2,16,16,16L304,40L303.9,22.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,67.3L218.1,16H216c-4,0-7.3,2.9-7.9,6.8L208,40l34.1,46.1L256,67.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344,224H168v32h49.7l-16.2,18c-3,3.3-2.7,8.3,0.6,11.3l11.9,10.7c3.3,3,8.3,2.7,11.3-0.6l30.8-34.2 l30.8,34.2c3,3.3,8,3.5,11.3,0.6l11.9-10.7c3.3-3,3.5-8,0.6-11.3l-16.2-18H344V224z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M264,256h-16c-6.2-6.2-9.8-9.8-16-16l0,0c6.2-6.2,9.8-9.8,16-16h16c6.2,6.2,9.8,9.8,16,16l0,0 C273.8,246.2,270.2,249.8,264,256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "218.1,16 293.9,16 256,67.3  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBelt);
export default __webpack_public_path__ + "static/media/White Belt.55749f08db2e292943f1cd36a05f7c29.svg";
export { ForwardRef as ReactComponent };